module.exports = __webpack_public_path__ + "media/src/images/icons/pencil-297ca4b6e2d357fb2da7687286a6a642.svg";